import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {

    connect() {
      this.clone_area = $(`#${this.element.dataset.clone}`);
      this.number_of_field = this.clone_area.find('.clone');
      if(this.clone_area == null) {
          toastr.error('Season Range Day: Falta el parametro "clone".')
      }else{
       if(this.number_of_field.length === 0){
           this.clone_area.append(this.tpl_season(this.number_of_field.length));
       }
      }
    }

    count_elements(){
         this.number_of_field = this.clone_area.find('.clone');
    }
    add(){
        this.count_elements();
        this.clone_area.append(this.tpl_season(this.number_of_field.length));
    }

    tpl_season(index){

        return `<div class="row clone" id="clone_${index}">
              <div class="col-md-2 col-12">
                <div class="form-group">
                  <label class="small mb-1" for="admin_cancelation_policy_from">De (Cantidad de días)
</label>                  <input class="form-control" required="required" min="0" step="1" type="number" name="admin_cancelation_policy[${index}][from]" id="admin_cancelation_policy_${index}_from">
                </div>
              </div>
              <div class="col-md-2 col-12">
                <div class="form-group">
                  <label class="small mb-1" for="admin_cancelation_policy_to">A (Cantidad de días)
</label>                  <input class="form-control" required="required" min="0" step="1" type="number" name="admin_cancelation_policy[${index}][to]" id="admin_cancelation_policy_${index}_to">
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-group">
                  <label class="small mb-1" for="admin_cancelation_policy_discount">Descuento %
</label>                  <input class="form-control" required="required" type="text" value="0.0" name="admin_cancelation_policy[${index}][discount]" id="admin_cancelation_policy_${index}_discount">
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="form-group">
                  <label class="small mb-1" for="admin_cancelation_policy_fixed_discount">Descuento Fijo
</label>                  <input class="form-control" required="required" type="number" value="5" name="admin_cancelation_policy[${index}][fixed_discount]" id="admin_cancelation_policy_${index}_fixed_discount">
                </div>
              </div>
               <div class="col-md-2 d-flex align-items-center justify-content-center">
                    <button type="button" class="btn btn-danger" onclick="$('#clone_${index}').remove();" ><span class="icon-trash"></span> </button>
             </div>
            </div>`
    }
}